(() => {
  const root = document.querySelector('[data-testorise-quiz]');
  if (!root) return;

  const card = root.querySelector('[data-quiz-card]');
  const progress = root.querySelector('[data-quiz-progress]');
  const progressLabel = root.querySelector('[data-quiz-progress-label]');
  let answers = {};
  try { answers = JSON.parse(sessionStorage.getItem('testoriseQuizDraft') || '{}'); } catch (_) {}
  if (!answers || typeof answers !== 'object' || Array.isArray(answers)) answers = {};
  let step = -1;
  let units = answers.units === 'metric' ? 'metric' : 'imperial';
  let loadingTimer;
  let loadingProgressTimer;
  const stopLoading = () => { clearTimeout(loadingTimer); clearInterval(loadingProgressTimer); };
  const ageDecade = () => {
    const group = new URLSearchParams(location.search).get('age_group');
    return (['20-29', '30-39', '40-49', '50+'].includes(group) ? group : '20-29').slice(0, 2);
  };
  const saveDraft = () => { try { sessionStorage.setItem('testoriseQuizDraft', JSON.stringify(answers)); } catch (_) {} };
  const setRoute = (route, replace = false) => {
    const url = new URL(location.href); url.searchParams.set('step', route); url.searchParams.delete('customer_posted'); url.hash = '';
    history[replace ? 'replaceState' : 'pushState']({}, '', url);
  };

  function track(name, detail = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...detail });
    document.dispatchEvent(new CustomEvent(`testorise:${name}`, { detail }));
  }

  const questions = [
  {
    "route": "goals",
    "title": "What are your goals?",
    "options": [
      "Losing weight",
      "Gaining muscle",
      "Improving my overall health"
    ],
    "multi": true,
    "key": "goals",
    "subtitle": "Please select all that apply"
  },
  {
    "route": "gained",
    "title": "Have you gained weight in the last year?",
    "options": [
      "Yes",
      "No"
    ],
    "multi": false,
    "key": "weight_gain"
  },
  {
    "route": "symptoms",
    "title": "Testosterone plays a key role in overall health. Do you experience any of these symptoms?",
    "options": [
      "Reduced muscle mass",
      "Low drive",
      "Hair loss (head, facial, body)",
      "Sugar and carbs cravings",
      "Prefer not to say",
      "None"
    ],
    "multi": true,
    "key": "physical_symptoms",
    "subtitle": "Please select all that apply"
  },
  {
    "route": "imbalance",
    "title": "Testosterone imbalances  affect more areas than often realized. Noticed any of these?",
    "options": [
      "Less strength and stamina than before",
      "Poor memory or focus",
      "No motivation / energy",
      "Stubborn chest fat",
      "Prefer not to say",
      "None"
    ],
    "multi": true,
    "key": "hormone_symptoms",
    "subtitle": "Please select all that apply"
  },
  {
    "route": "testosterone",
    "title": "Do you have any of these conditions that affect testosterone?",
    "options": [
      "Diabetes",
      "Sleep apnea",
      "Liver problems",
      "High blood pressure",
      "Prefer not to say",
      "None"
    ],
    "multi": true,
    "key": "conditions",
    "subtitle": "Please select all that apply"
  },
  {
    "route": "habits",
    "title": "Are you prone to any of these habits?",
    "options": [
      "Smoking",
      "Alcohol consumption",
      "High daily carb intake",
      "Eating hormone-infused meat",
      "Prefer not to say",
      "None"
    ],
    "multi": true,
    "key": "habits",
    "subtitle": "Please select all that apply"
  },
  {
    "route": "emotional",
    "title": "What best describes your emotional state on a daily basis?",
    "options": [
      "Mood changes",
      "Irritability or stress",
      "Anxiety or depression",
      "Happy and calm"
    ],
    "multi": false,
    "key": "mood"
  },
  {
    "route": "sleep",
    "title": "How much sleep do you get on average?",
    "options": [
      "Less than 5 hours",
      "5-6 hours",
      "7-8 hours",
      "More than 8 hours"
    ],
    "multi": false,
    "key": "sleep"
  },
  {
    "route": "age",
    "title": "How old are you?",
    "multi": false,
    "key": "age",
    "input": {
      "type": "number",
      "label": "Age",
      "min": 18,
      "max": 100
    }
  },
  {
    "route": "height",
    "title": "What\u2019s your height?",
    "multi": false,
    "key": "height",
    "fields": [
      {
        "key": "feet",
        "type": "number",
        "label": "Feet",
        "min": 3,
        "max": 8
      },
      {
        "key": "inches",
        "type": "number",
        "label": "Inches",
        "min": 0,
        "max": 11
      }
    ]
  },
  {
    "route": "weight",
    "title": "How much would you like to lose?",
    "multi": false,
    "key": "weight",
    "fields": [
      {
        "key": "current",
        "type": "number",
        "label": "Current weight (lb)",
        "min": 70,
        "max": 700
      },
      {
        "key": "goal",
        "type": "number",
        "label": "Goal weight (lb)",
        "min": 70,
        "max": 700
      }
    ]
  }
];

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  }

  function updateProgress() {
    const visibleStep = Math.min(step + 1, questions.length);
    progress.style.width = `${(visibleStep / questions.length) * 100}%`;
    progressLabel.innerHTML = step < questions.length ? `<strong>${visibleStep}</strong> of ${questions.length}` : 'Results';
  }

  function render() {
    stopLoading();
    root.classList.remove('is-intro', 'is-results', 'is-loading');
    updateProgress();
    const q = questions[step];
    let stored = answers[q.key];
    let fields = q.fields || (q.input ? [{ key: q.key, ...q.input }] : []);
    if (units === 'metric' && q.key === 'height') {
      fields = [{ key: 'cm', type: 'number', label: 'Height (cm)', min: 100, max: 250 }];
      stored = stored ? { cm: Math.round((Number(stored.feet) * 12 + Number(stored.inches)) * 2.54) } : {};
    }
    if (units === 'metric' && q.key === 'weight') {
      fields = fields.map(field => ({ ...field, label: field.label.replace('(lb)', '(kg)'), min: 32, max: 318 }));
      stored = stored ? { current: Math.round(Number(stored.current) / 2.20462), goal: Math.round(Number(stored.goal) / 2.20462) } : {};
    }
    let controls = '';

    if (q.options) {
      controls = `<div class="tq-options">${q.options.map((option) => {
        const selected = Array.isArray(stored) ? stored.includes(option) : stored === option;
        return `<button class="tq-option${q.multi ? ' is-multi' : ''}${selected ? ' is-selected' : ''}" type="button" aria-pressed="${selected}" data-value="${escapeHtml(option)}">${escapeHtml(option)}</button>`;
      }).join('')}</div>`;
    } else {
      controls = `<div class="tq-fields">${fields.map((field) => `<label><span>${escapeHtml(field.label)}</span><input type="${field.type}" data-field="${field.key}" min="${field.min}" max="${field.max}" required inputmode="numeric" value="${escapeHtml((stored && stored[field.key]) ?? '')}"></label>`).join('')}</div>`;
    }

    card.innerHTML = `<div class="tq-question"><h1>${escapeHtml(q.title)}</h1>${q.subtitle ? `<p>${escapeHtml(q.subtitle)}</p>` : ''}${['height', 'weight'].includes(q.key) ? `<div class="tq-units" aria-label="Measurement units"><button type="button" data-units="imperial" aria-pressed="${units === 'imperial'}">IMPERIAL</button><button type="button" data-units="metric" aria-pressed="${units === 'metric'}">METRIC</button></div>` : ''}${controls}${q.multi || !q.options ? `<div class="tq-nav"><button class="tq-back" type="button" data-back ${step === 0 ? 'disabled' : ''}>← Back</button><button class="tq-continue" type="button" data-next ${q.multi && (!stored || stored.length === 0) ? 'disabled' : ''}>CONTINUE</button></div>` : ''}</div>`;

    card.querySelectorAll('[data-units]').forEach(button => button.addEventListener('click', () => { units = button.dataset.units; answers.units = units; saveDraft(); render(); }));
    card.querySelectorAll('[data-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const value = button.dataset.value;
        if (q.multi) {
          const current = Array.isArray(answers[q.key]) ? answers[q.key] : [];
          if (value === 'None' || value === 'Prefer not to say') {
            answers[q.key] = [value];
            card.querySelectorAll('[data-value]').forEach((item) => item.classList.toggle('is-selected', item === button));
          } else {
            const filtered = current.filter((item) => item !== 'None' && item !== 'Prefer not to say');
            answers[q.key] = filtered.includes(value) ? filtered.filter((item) => item !== value) : [...filtered, value];
            button.classList.toggle('is-selected');
            card.querySelectorAll('[data-value="None"], [data-value="Prefer not to say"]').forEach((item) => item.classList.remove('is-selected'));
          }
          card.querySelectorAll('[data-value]').forEach(item => item.setAttribute('aria-pressed', String(answers[q.key].includes(item.dataset.value))));
          saveDraft();
          const nextButton = card.querySelector('[data-next]');
          if (nextButton) nextButton.disabled = !answers[q.key] || answers[q.key].length === 0;
        } else {
          answers[q.key] = value;
          saveDraft();
          next();
        }
      });
    });

    card.querySelector('[data-back]')?.addEventListener('click', back);
    card.querySelector('[data-next]')?.addEventListener('click', () => {
      if (!q.options) {
        const result = {};
        let valid = true;
        card.querySelectorAll('[data-field]').forEach((input) => {
          if (!input.checkValidity()) valid = false;
          result[input.dataset.field] = input.value;
        });
        if (!valid) {
          [...card.querySelectorAll('[data-field]')].find(input => !input.checkValidity())?.reportValidity();
          return;
        }
        if (units === 'metric' && q.key === 'height') {
          const inches = Math.round(Number(result.cm) / 2.54);
          answers[q.key] = { feet: String(Math.floor(inches / 12)), inches: String(inches % 12) };
        } else if (units === 'metric' && q.key === 'weight') {
          answers[q.key] = { current: String(Number(result.current) * 2.20462), goal: String(Number(result.goal) * 2.20462) };
        } else answers[q.key] = result;
        saveDraft();
      }
      if (q.multi && (!answers[q.key] || answers[q.key].length === 0)) return;
      next();
    });
  }

  function next() {
    if (step < questions.length - 1) {
      step += 1;
      setRoute(questions[step].route);
      render();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    showLoading();
  }

  function back() {
    if (step <= 0) { step = -1; setRoute('intro'); showIntro(); return; }
    step = Math.min(step - 1, questions.length - 1);
    setRoute(questions[step].route);
    render();
  }

  function showLoading() {
    stopLoading();
    step = questions.length;
    root.classList.remove('is-intro', 'is-results');
    root.classList.add('is-loading');
    if (new URLSearchParams(location.search).get('step') !== 'loader') setRoute('loader');
    updateProgress();
    card.innerHTML = root.querySelector('[data-quiz-loader-template]').innerHTML;
    if (!answers.planStarted) answers.planStarted = new Date().toISOString();
    saveDraft();
    try { sessionStorage.setItem('testoriseQuiz', JSON.stringify(answers)); } catch (_) {}
    // Answers remain in this browser; never publish health information to analytics.
    const steps = [...card.querySelectorAll('[data-loader-step]')];
    const reviews = [...card.querySelectorAll('[data-loader-review]')];
    const ring = card.querySelector('[role="progressbar"]');
    const started = performance.now();
    const duration = 9000;
    let previousStep = -1;
    const paint = () => {
      const elapsed = performance.now() - started;
      const percent = Math.min(100, Math.floor(elapsed / duration * 100));
      const active = Math.min(steps.length, Math.floor(percent / 25));
      ring.querySelector('.tq-loader-ring__arc').style.strokeDashoffset = String(339.3 * (1 - percent / 100));
      ring.setAttribute('aria-valuenow', String(percent));
      card.querySelector('[data-loader-percent]').textContent = `${percent}%`;
      steps.forEach((item, index) => item.dataset.state = index < active ? 'done' : index === active ? 'current' : 'pending');
      reviews.forEach((review, index) => review.hidden = index !== Math.min(1, Math.floor(elapsed / 4500)));
      if (active !== previousStep) {
        previousStep = active;
        card.querySelector('[data-loader-status]').textContent = active < steps.length ? steps[active].textContent : 'Your summary is ready';
      }
    };
    paint();
    loadingProgressTimer = setInterval(paint, 100);
    loadingTimer = setTimeout(() => {
      clearInterval(loadingProgressTimer); paint();
      loadingTimer = setTimeout(() => { setRoute('email', true); showEmailGate(); }, 350);
    }, duration);
    window.scrollTo({top:0,behavior:'instant'});
  }

  root.querySelector('[data-global-back]')?.addEventListener('click', () => {
    const route = new URLSearchParams(location.search).get('step');
    if (/^c[1-8]$/.test(route || '')) { const n = Number(route.slice(1)); setRoute(n > 1 ? `c${n-1}` : 'email'); renderRoute(); }
    else if (step >= 0) back();
    else window.location.href = '/pages/quiz';
  });

  function showEmailGate() {
    step = questions.length;
    root.classList.remove('is-intro', 'is-results', 'is-loading');
    updateProgress();
    const template = root.querySelector('[data-quiz-email-template]');
    card.innerHTML = template.innerHTML;
    const form = card.querySelector('form');
    if (form) {
      // Meta's pixel (Facebook & Instagram channel, open sandbox) hooks this form's submit for its
      // automatic SubscribedButtonClick event and then re-submits the form natively, which reloads the
      // page mid-quiz and lets Shopify bot-challenge the post. The gate only ever posts via fetch.
      form.submit = () => {};
      const returnUrl = new URL(location.href); returnUrl.searchParams.set('step', 'c1'); returnUrl.searchParams.delete('customer_posted'); returnUrl.hash = '';
      form.querySelector('[name=return_to]').value = returnUrl.pathname + returnUrl.search;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.busy) return;
        form.dataset.busy = 'true';
        try { localStorage.setItem('testoriseQuizComplete', 'true'); } catch (_) {}

        const submitButton = form.querySelector('[type="submit"]');
        const email = new FormData(form).get('contact[email]');
        const companyId = root.dataset.klaviyoCompanyId;
        const listId = root.dataset.klaviyoListId;
        const relayUrl = root.dataset.leadRelay;
        // Quiz answers stay in sessionStorage; only the email and Meta's own identifiers leave the browser.
        const eventId = window.crypto && crypto.randomUUID ? crypto.randomUUID() : `quiz-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const cookie = name => (document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`)) || [])[1] || '';
        const lead = { email, event_id: eventId, fbp: cookie('_fbp'), fbc: cookie('_fbc'), fbclid: new URLSearchParams(location.search).get('fbclid') || '', page_url: location.origin + location.pathname };
        try { if (email && typeof window.fbq === 'function') window.fbq('track', 'Lead', {}, { eventID: eventId }); } catch (_) {}

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'UNLOCKING…';
        }

        // The relay (scripts/quiz-lead-relay) writes the lead through Klaviyo's server API, which
        // never drops sign-ups; Klaviyo's public client endpoint is only the fallback.
        let relayed = false;
        try {
          if (email && relayUrl) {
            const response = await fetch(relayUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(lead),
            });
            relayed = response.ok;
          }
        } catch (_) {
          // Fall through to the client API below.
        }

        try {
          if (!relayed && email && companyId && listId) {
            const fallback = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                revision: '2026-07-15',
              },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: 'Testorise Quiz',
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email,
                          properties: {
                            signup_source: 'Testorise Quiz',
                            quiz_completed: true,

                          },
                          subscriptions: {
                            email: { marketing: { consent: 'SUBSCRIBED' } },
                          },
                        },
                      },
                    },
                  },
                  relationships: {
                    list: { data: { type: 'list', id: listId } },
                  },
                },
              }),
            });
            relayed = fallback.ok;
          }
        } catch (_) {
          // Shopify remains the durable form destination if Klaviyo is unavailable.
        } finally {
          try {
            await fetch(form.action, {
              method: 'POST',
              body: new FormData(form),
              headers: { Accept: 'application/json' },
            });
          } catch (_) {
            // The quiz result remains available even if Shopify contact capture is unavailable.
          }
          setRoute('c1');
          renderRoute();
        }
      });
    }
  }

  function showIntro() {
    root.classList.remove('is-results', 'is-loading');
    root.classList.add('is-intro');
    const template = root.querySelector(`[data-quiz-intro="${ageDecade()}"]`);
    card.innerHTML = template.innerHTML;
    card.querySelector('[data-intro-continue]').addEventListener('click', () => { step = 0; setRoute('goals'); render(); });
  }
  function renderRoute() {
    stopLoading();
    let route = new URLSearchParams(location.search).get('step');
    if (new URLSearchParams(location.search).get('customer_posted') === 'true' && location.hash === '#TestoriseQuizForm') {
      route = 'c1'; setRoute(route, true);
      try { sessionStorage.setItem('testoriseQuiz', JSON.stringify(answers)); localStorage.setItem('testoriseQuizComplete', 'true'); } catch (_) {}
    }
    // A result, loader or email link opened without this browser's quiz answers (shared or
    // bookmarked URL) starts the quiz from the beginning instead of showing empty results.
    const hasAnswers = Boolean(answers.goals || answers.weight || answers.age);
    if (!hasAnswers && (route === 'loader' || route === 'email' || /^c[1-8]$/.test(route || ''))) {
      const start = new URL(location.href); start.search = ''; start.hash = '';
      history.replaceState({}, '', start);
      route = null;
    }
    const entry = document.getElementById('testorise-age-entry');
    const showEntry = !route && !new URLSearchParams(location.search).has('age_group');
    if (entry) entry.hidden = !showEntry;
    root.hidden = showEntry;
    if (showEntry) { step = -1; return; }
    const found = questions.findIndex(q => q.route === route);
    if (found >= 0) { step = found; render(); }
    else if (route === 'loader') showLoading();
    else if (route === 'email') showEmailGate();
    else if (/^c[1-8]$/.test(route || '')) {
      step = questions.length;
      root.classList.remove('is-intro', 'is-loading');
      window.TestoriseResults.show(root, card, answers, Number(route.slice(1)), nextRoute => { setRoute(nextRoute); renderRoute(); });
    }
    else { step = -1; showIntro(); }
  }
  // Continue works after a mouse selection or after an input loses focus, too.
  // Capture Enter before a focused multi-choice button toggles the answer off.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.isComposing || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || root.hidden) return;
    const target = event.target;
    if (!(target instanceof Element) || (!root.contains(target) && target !== document.body && target !== document.documentElement && !target.contains(root))) return;
    if (event.repeat) { event.preventDefault(); return; }
    if (target.closest('a, textarea, select, form, [contenteditable="true"]')) return;
    const focusedButton = target.closest('button');
    if (focusedButton && !focusedButton.matches('.tq-option.is-multi')) return;
    const continueButton = card.querySelector('[data-next], [data-intro-continue], [data-result-next], form [type="submit"]');
    if (!continueButton || continueButton.disabled) return;
    event.preventDefault();
    continueButton.click();
  }, true);
  window.addEventListener('popstate', renderRoute);
  renderRoute();
  root.dataset.quizReady = 'true';
})();
